module.exports = __webpack_public_path__ + "img/EU-flagga+Europeiska+jordbruksfonden+svartvit.fcf448f6.jpg";